import React from "react";
import { Form, Select } from "antd";

const FormSelect = ({
  label,
  name,
  rules,
  options,
  placeholder,
  size = "large",
  onChange,
  ...rest
}) => (
  <Form.Item
    label={label}
    name={name}
    rules={rules}
    {...rest}
    className="custom-select"
  >
    <Select
      placeholder={placeholder}
      size={size}
      options={options}
      onChange={onChange}
      showSearch
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
    />
  </Form.Item>
);

export default FormSelect;

export const FormMultiSelect = ({
  label,
  name,
  rules,
  options,
  placeholder,
  size = "large",
  onChange,
  mode = null,
  ...rest
}) => (
  <Form.Item
    label={label}
    name={name}
    rules={rules}
    {...rest}
    className="custom-select"
  >
    <Select
      placeholder={placeholder}
      size={size}
      options={options}
      onChange={onChange}
      mode={mode}
      showSearch
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
    />
  </Form.Item>
);

export const FormMultiSelectTags = ({
  label,
  name,
  rules,
  options,
  placeholder,
  size = "large",
  onChange,
  mode = null,
  ...rest
}) => (
  <Form.Item
    label={label}
    name={name}
    rules={[
      ...(rules || []),
      { 
        validator: (_, value) => {
          if (value?.some((val) => val.length > 30)) {
            return Promise.reject("Each selection must be 30 characters max.");
          }
          return Promise.resolve();
        }
      }
    ]}
    {...rest}
    className="custom-select"
  >
    <Select
      placeholder={placeholder}
      size={size}
      options={options.map((opt) => ({
        ...opt,
        label: opt.label.slice(0, 30),
        value: opt.value.slice(0, 30)
      }))}
      onChange={(selectedValues) => {
        const slicedValues = selectedValues.map((val) => val.slice(0, 30));
        onChange?.(slicedValues);
      }}
      mode={mode}
      showSearch
      filterOption={(input, option) =>
        option.label.toLowerCase().includes(input.toLowerCase())
      }
    />
  </Form.Item>
);
